import { Center, Loader, LoadingOverlay, ModalCloseButton, ModalHeader, ModalTitle, Stack, Text } from '@mantine/core';
import { useMemo } from 'react';

import { Batch, BatchBrokerStatusEnum, BatchStatusEnum, Broker } from '@e-origin/shared';

import { EucdmToggle } from '@components';
import { useRetrieveFinalizeDeclarationsInfo } from '@hooks/batch';
import { useSettings } from '@hooks/useSettings';
import { BeforeSendingBatch } from './BeforeSendingBatch';

export interface FinalizeBatchProps {
  batch: Batch;
  onHide(): void;
}

export const FinalizeBatch: React.FC<FinalizeBatchProps> = (props) => {
  const { batch } = props;
  const { data: settings } = useSettings();

  const { data: declaration, isLoading } = useRetrieveFinalizeDeclarationsInfo(batch._id);

  const notEditable = useMemo(() => {
    if (settings.isForwarder && batch.status.brokerStatus === BatchBrokerStatusEnum.SENT) {
      return true;
    }

    if (batch.status.value !== BatchStatusEnum.SUCCESS) {
      return false;
    }

    const { sent, preSent, preAccepted, rejected, analysis } = batch.statistics;
    if (analysis > 0) {
      return false;
    }

    return (sent > 0 || preSent > 0 || preAccepted > 0) && rejected === 0;
  }, []);

  if (!declaration) {
    return <LoadingOverlay visible={isLoading} overlayProps={{ radius: 'sm', blur: 2 }} />;
  }

  return (
    <>
      <ModalHeader>
        <Stack>
          <ModalTitle fw="bold" data-pw="finalize-modal-title">
            {/* todo: remove this once the new finalize batch is ready */}
            [NEW] Finalize Batch
          </ModalTitle>
          <Text data-pw="finalize-batch-name">{props.batch.name}</Text>
        </Stack>
        <Stack align="flex-end" gap="sm">
          <ModalCloseButton />
          <EucdmToggle label="Toggle view: EUCDM code hints" size="sm" />
        </Stack>
      </ModalHeader>

      {!declaration ? (
        <Center h={300}>
          <Loader />
        </Center>
      ) : (
        <BeforeSendingBatch declaration={declaration} onHide={props.onHide} disabled={notEditable} brokerId={(props.batch.broker as Broker)?._id} />
      )}
    </>
  );
};
